import { render } from "./ExternalLabResultsTab.vue?vue&type=template&id=fbfdaa9c&scoped=true"
import script from "./ExternalLabResultsTab.vue?vue&type=script&lang=js"
export * from "./ExternalLabResultsTab.vue?vue&type=script&lang=js"

import "./ExternalLabResultsTab.vue?vue&type=style&index=0&id=fbfdaa9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbfdaa9c"]])

export default __exports__